const luxuraCat_b = [
  {
    link: "Supplemetns",
    name: "Supplemetns",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786564237170-1-Supplemetns.jpg",
  },
  {
    link: "Sports",
    name: "Sports",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786564237170-2-Sports.jpg",
  },
  {
    link: "Phone Accessories",
    name: "Phone Accessories",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786564237170-3-Phone-Accessories.jpg",
  },
  {
    link: "Computers",
    name: "Computers",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786564269163-0-Computers.jpg",
  },
];

const luxuraFashion = [
  {
    link: "watches",
    name: "watches",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786564237170-0-Watches.jpg",
  },
  {
    link: "Fashion",
    name: "Fashion",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786564237170-7-Fashion.jpg",
  },
  {
    link: "Electronics",
    name: "Electronics",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786564237170-8-Electronics.jpg",
  },
  {
    link: "Beauty Cosmetics",
    name: "Beauty Cosmetics",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786564269163-1-Beauty--Cosmetics.jpg",
  },
  {
    link: "gaming console",
    name: "gaming_console",
    image: "https://d3px821xl4957r.cloudfront.net/assets/images/1786564237170-6-Gaming.jpg",
  },
];

const HomeData = {
  category_b: luxuraCat_b,
  fashion: luxuraFashion,
};

export default HomeData;
